import MapboxDraw from "@mapbox/mapbox-gl-draw";

import {
  geojsonTypes,
  cursors,
  types,
  modes
} from "@mapbox/mapbox-gl-draw/src/constants";

import doubleClickZoom from "@mapbox/mapbox-gl-draw/src/lib/double_click_zoom";
import circle from "@turf/circle";

const ViewportCircleMode = { ...MapboxDraw.modes.draw_polygon };

ViewportCircleMode.getLengthByPixel = function(width = 20) {
  const y = this.map._container.clientHeight / 2;
  const maxMeters = this.getDistance(
    this.map.unproject([0, y]),
    this.map.unproject([width, y])
  );

  return maxMeters / 1000;
};

ViewportCircleMode.getDistance = function(latlng1, latlng2) {
  // Uses spherical law of cosines approximation.
  const R = 6371000;

  const rad = Math.PI / 180,
    lat1 = latlng1.lat * rad,
    lat2 = latlng2.lat * rad,
    a =
      Math.sin(lat1) * Math.sin(lat2) +
      Math.cos(lat1) *
        Math.cos(lat2) *
        Math.cos((latlng2.lng - latlng1.lng) * rad);

  return R * Math.acos(Math.min(a, 1));
};

ViewportCircleMode.onSetup = function(opts) {
  const polygon = this.newFeature({
    type: geojsonTypes.FEATURE,
    properties: {
      isCircle: true,
      center: []
    },
    geometry: {
      type: geojsonTypes.POLYGON,
      coordinates: [[]]
    }
  });

  this.addFeature(polygon);

  this.clearSelectedFeatures();
  doubleClickZoom.disable(this);
  this.updateUIClasses({ mouse: cursors.ADD });
  this.activateUIButton(types.POLYGON);
  this.setActionableState({
    trash: true
  });

  const state = {
    viewportRadiusInPixels: opts.viewportRadiusInPixels,
    polygon,
    currentVertexPosition: 0
  };

  const onZoomEnd = function() {
    this.onMouseMove(state, {
      lngLat: {
        lng: state.polygon.properties.center[0],
        lat: state.polygon.properties.center[1]
      }
    });

    // Force store to render
    this._ctx.store.render();
  }.bind(this);

  this.map.on("zoomend", onZoomEnd);

  state.onZoomEnd = onZoomEnd;

  return state;
};

ViewportCircleMode.onMouseMove = function(state, e) {
  const center = [e.lngLat.lng, e.lngLat.lat];
  const radius = this.getLengthByPixel(state.viewportRadiusInPixels);
  const circleFeature = circle(center, radius);
  state.polygon.setCoordinates(circleFeature.geometry.coordinates);
  state.polygon.properties.center = center;
  state.polygon.properties.radiusInKm = radius;
};

ViewportCircleMode.clickAnywhere = function(state) {
  if (state.currentVertexPosition === 0) {
    state.currentVertexPosition++;
  }

  return this.changeMode(modes.SIMPLE_SELECT, {
    featureIds: [state.polygon.id]
  });
};

const viewportCircleModeOnStop = ViewportCircleMode.onStop;
ViewportCircleMode.onStop = function(state) {
  viewportCircleModeOnStop.call(this, state);
  this.map.off("zoomend", state.onZoomEnd);
};

export { ViewportCircleMode };
